<span class="se-icons bell-format" [ngClass]="{'notifications-bubble': notificationsCounts !== 0}" (click)="showNotificationModal()">notification_on</span>

<app-common-modal  #notificationsModal class="notifications-modal" [name]="'Notifications'" [title]="'My Notifications'" [withFooter]="false" [size]="'modal-xl'">
  <div modal-body>
    <app-news-notifications-card *ngFor="let notif of notifications" [newsCard]="notif" [type]="'notifications'">
    </app-news-notifications-card>
    <h2  *ngIf="notifications.length === 0" translate>T_NO_NOTIFICATIONS</h2>
  </div>
</app-common-modal>
